import http from './Http';
import Service from './Service';
import * as CONSTANTS from '../constants/constants';
import { switchPayload } from './masterAccess';

/**
 * @type QuotationService
 */
export default class AuthService extends Service {

    get_user() {
        return http.get('getUser', {
            headers: this.getHeaders(),
            timeout: 200000
        })
    }

    /**
     * As contas que este login alcança.
     *
     * URL absoluta de propósito: o `http` daqui aponta para a API legada
     * (API_URL), e estas duas rotas vivem no kyojin (API_V3_URL), o mesmo base
     * que o `/auth` do signin já usa.
     *
     * Devolve lista VAZIA para quem não tem `login_id` — usuário criado antes
     * do login central, ou comprador criado pelo BuyerController, que não grava
     * a coluna. Por isso o cabeçalho esconde o seletor em vez de mostrar um que
     * não funciona.
     */
    my_accounts() {
        return http.get(`${CONSTANTS.API_V3_URL}/login/accounts`, {
            headers: this.getHeaders()
        })
    }

    /**
     * Busca master: qualquer cliente/fornecedor ativo. So responde para login
     * master (403 para os demais), e o cabecalho so chama quando
     * /login/accounts disse is_master.
     */
    search_master_accounts(q) {
        return http.get(`${CONSTANTS.API_V3_URL}/login/accounts/search`, {
            headers: this.getHeaders(),
            params: { q }
        })
    }

    /**
     * Troca a conta ativa. Devolve um token NOVO — quem chama precisa limpar o
     * estado da conta anterior antes de usá-lo (ver Header.vue). Recebe a
     * conta inteira: conta master vai por master_target, as demais por user_id.
     */
    switch_account(account) {
        return http.post(`${CONSTANTS.API_V3_URL}/login/switch-account`, switchPayload(account), {
            headers: this.getHeaders()
        })
    }

}
